import PropTypes from "prop-types";
import { renderFinalPrice } from "helpers/utils";
import dynamic from "next/dynamic";
import Button from "../../../shared/button/Button";
import { useMediaQueryContext } from "../../../../lib/mediaQueryContext";

import {
    Wrapper,
    ButtonContainer,
    Info,
    Price,
    Quantity,
    Totals
} from "./Summary.styled";

const Throbber = dynamic(() => import("components/shared/throbber/Throbber"));

function Summary({
    packageQuantity,
    subtotal,
    onSubmit,
    showOverlay,
    isButtonDisabled,
    className,
    children
}) {
    const { mobileView } = useMediaQueryContext();

    return (
        <Wrapper>
            {children}
            <Info className={className}>
                <Totals>
                    <Quantity>
                        {packageQuantity}x Lees! Cadeaukaart pakketten
                    </Quantity>
                    <Price>
                        <span>Totaalprijs</span>
                        {renderFinalPrice(subtotal, {
                            canBeZero: true
                        })}
                    </Price>
                </Totals>
                <ButtonContainer>
                    <Button
                        onClick={onSubmit}
                        aria-label="bestelling plaatsen"
                        disabled={isButtonDisabled}
                    >
                        {showOverlay && <Throbber />}
                        {mobileView ? "Bestellen" : "Verder naar bestellen"}
                    </Button>
                </ButtonContainer>
            </Info>
        </Wrapper>
    );
}

Summary.propTypes = {
    packageQuantity: PropTypes.number,
    subtotal: PropTypes.number,
    showOverlay: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    isButtonDisabled: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node
};

Summary.defaultProps = {
    packageQuantity: 0,
    subtotal: 0,
    showOverlay: false,
    isButtonDisabled: true,
    className: "",
    children: null
};

export default Summary;
